import React from "react";

// Locals
import LeftPanel from "./leftPanel";
import CenterInfoPanel from "./centerInfoPanel";

// Types
import type { WorkspaceUser } from "../../users/types";

// Styles
import useStyles from "../styles";

interface Props {
  user: WorkspaceUser;
}

const UserSection: React.FC<Props> = ({ user }) => {
  const classes = useStyles();

  return (
    <div className={`myitems-userinfo ${classes.userSectionWrap}`}>
      <LeftPanel user={user} />
      <CenterInfoPanel user={user} />
    </div>
  );
};

export default UserSection;
